import { render, staticRenderFns } from "./EmbedIText.vue?vue&type=template&id=2c93ac47&scoped=true&"
import script from "./EmbedIText.vue?vue&type=script&lang=js&"
export * from "./EmbedIText.vue?vue&type=script&lang=js&"
import style0 from "./EmbedIText.vue?vue&type=style&index=0&id=2c93ac47&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c93ac47",
  null
  
)

export default component.exports